// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3ygO6","checkboxCol":"Table_checkboxCol__Z5AQW","emailCol":"Table_emailCol__2ZMwi","actionCol":"Table_actionCol__15EaV"};